/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Peça suporte à equipe ou ao administrador.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Não foi possível obter nenhum resultado para esta pesquisa',
};
